// frontend/src/components/DeleteConfirmModal.tsx
import React, { useState } from 'react';
import { Box, Button, Modal, Text } from '@nimbus-ds/components';

interface DeleteConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  title: string;
  message: string;
}

export const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
}) => {
  const [deleting, setDeleting] = useState(false);

  const handleConfirm = async () => {
    setDeleting(true);
    try {
      await onConfirm();
      onClose();
    } finally {
      setDeleting(false);
    }
  };

  return (
    <Modal open={isOpen} onDismiss={onClose}>
      <Modal.Header title={title} />
      <Modal.Body padding="base">
        <Text>{message}</Text>
      </Modal.Body>
      <Modal.Footer>
        <Box display="flex" gap="2" justifyContent="flex-end">
          <Button appearance="transparent" onClick={onClose} disabled={deleting}>
            Cancelar
          </Button>
          <Button appearance="danger" onClick={handleConfirm} disabled={deleting}>
            {deleting ? 'Eliminando...' : 'Eliminar'}
          </Button>
        </Box>
      </Modal.Footer>
    </Modal>
  );
};
